const ibesDelivery = (state = {}, data) => {
    switch (data.type) {
        case 'SET_EXPRESS_DELIVERY':
            if (data.value === null) {
                return Object.keys(state)
                    .filter(key => key !== 'expressDelivery')
                    .reduce((obj, key) => {
                        obj[key] = state[key];
                        return obj;
                    }, {});
            }
            return {
                ...state,
                expressDelivery: data.value,
            };
        case 'SET_IBES_HOME_DELIVERY':
            if (data.value === null) {
                return Object.keys(state)
                    .filter(key => key !== 'ibesHomeDelivery')
                    .reduce((obj, key) => {
                        obj[key] = state[key];
                        return obj;
                    }, {});
            }
            return {
                ...state,
                ibesHomeDelivery: data.value,
            };
        default:
            return state;
    }
};

export default ibesDelivery;
